import { Modal } from 'antd';
import {useEffect} from "react";
const confirm = Modal.confirm;

export default function ConfirmModal(props) {


    confirm({
        title: props?.title,
        content: props?.description,
        onOk() {
            props?.onOk(props?.id);
        },
        onCancel() {
            console.log('Cancel');
        },
    });


    return null;
}